module.exports = __webpack_public_path__ + "static/media/ic-man.f8aa3217.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ic-man.svg
// module id = 1956
// module chunks = 0